export default __webpack_public_path__ + "static/shanteas-821f92a4d7623907dd551dc36f78482b.png";